import i18n from '../utils/i18n';

/**
 * 1. Aplicamos este fix por que como el MenuDrawer está fixed, window.scrollTo hace
 *    que el scroll se mueva en el body y no en dicho MenuDrawer.
 */

const Form                = document.querySelector( '.formcontact' );
const FormName            = Form && Form.querySelector( '#contact_name' );
const FormEmail           = Form && Form.querySelector( '#contact_email' );
const FormOrganization    = Form && Form.querySelector( '#contact_organization' );
const FormRole            = Form && Form.querySelector( '#contact_role' );
const FormReason          = Form && Form.querySelector( '#contact_reason' );
const FormMessage         = Form && Form.querySelector( '#contact_description' );
const FormSuscribe        = Form && Form.querySelector( '#contact_suscribe' );
const FormNonce           = Form && Form.querySelector( '[name="nonce"]' );
const FormBtnSubmit       = Form && Form.querySelector( '.formsubmit button' );
const BtnSubmitText       = FormBtnSubmit && FormBtnSubmit.querySelector( '.button__text' );
const backupBtnSubmitText = BtnSubmitText && BtnSubmitText.textContent;
const messages            = i18n.forms;
let message               = {};
let FormBox               = Form && [].slice.call( Form.querySelectorAll( '.formbox--focus' ) );
let lang                  = document.documentElement.lang || 'en-US';
let hasError              = false;

switch ( lang ) {
    case 'es-ES':
    case 'es-AR':
        message = messages.es_ar;
    break;
    default:
        message = messages.en_us;
    break;
}

function Constructor() {
    if( !Form ) return;

    FormBox.forEach( formBox => {
        let formInput = formBox.querySelector( 'input, textarea, checkbox, select' );
        formInput.addEventListener( 'focus', onFocusIn, false );
        formInput.addEventListener( 'focusout', onFocusOut, false );
    });
    if ( Form ) {
        Form.addEventListener( 'submit', onSubmit, false );
    }
}

function cleanInputError() {
    const fieldset = this.parentNode.parentNode;
    const hint     = fieldset.querySelector( '.formhint' );
    fieldset.classList.remove( 'formfield--error' );
    hint.innerHTML = '';
}

function addInputError( input, message ) {
    const fieldset = input.parentNode.parentNode;
    const hint     = fieldset.querySelector( '.formhint' );
    fieldset.classList.add( 'formfield--error' );
    hint.textContent = message;
}

function isValidName() {
    return FormName.value.length <= 40;
}

function isValidEmail() {
    const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test( FormEmail.value.toLowerCase() );
}

function isValidMessage() {
    return FormMessage.value.length <= 1600;
}

function isValid( input ) {
    if ( input.value == '' || input.value.length <= 60 ) {
        return true;
    } else {
        return false;
    }
}

function isEmpty( field ) {
    return !field.value || field.value === '' || field.value === undefined;
}

function scrollToError() {
    const formErrror = Form.querySelector( '.formfield--error' );

    if( document.body.style.overflow == 'hidden' ) { /* 1 */
        var menuDrawer = document.querySelector( '.menu-drawer__container' );
        if(  menuDrawer && formErrror ) {
            menuDrawer.scrollTop = formErrror.offsetTop - 100;
            return;
        }
    }

    window.scrollTo( 0, formErrror.offsetTop - 100 );
}

function showError() {
    setButtonState( FormBtnSubmit, 'error' );
    addInputError( FormBtnSubmit, message.global );
}

function showSuccess() {
    setButtonState( FormBtnSubmit, 'success' );
    cleanInputError.apply( FormBtnSubmit );
    cleanFocusedClass();
    Form.reset();
}

function onChange( e ) {

    if ( isEmpty( FormName ) ) {
        hasError = true;
        addInputError( FormName, message.required );
    } else {
        if ( ! isValidName() ) {
            hasError = true;
            addInputError( FormName, message.fullname );
        } else {
            cleanInputError.apply( FormName );
        }
    }

    if ( ! isValidEmail() ) {
        hasError = true;
        addInputError( FormEmail, message.email );
    } else {
        cleanInputError.apply( FormEmail );
    }

    if ( isEmpty( FormMessage ) ) {
        hasError = true;
        addInputError( FormMessage, message.required );
    } else {
        if ( ! isValidMessage() ) {
            hasError = true;
            addInputError( FormMessage, message.textarea );
        } else {
            cleanInputError.apply( FormMessage );
        }
    }

    if ( ! isValid( FormOrganization ) ) {
        hasError = true;
        addInputError( FormOrganization, message.company );
    } else {
        cleanInputError.apply( FormOrganization );
    }

    if ( ! isValid( FormRole ) ) {
        hasError = true;
        addInputError( FormRole, message.role );
    } else {
        cleanInputError.apply( FormRole );
    }

    // if ( isEmpty( FormReason ) ) {
    //     hasError = true;
    //     addInputError( FormReason, message.required );
    // } else {
    //     cleanInputError.apply( FormReason );
    // }
}

function onSubmit( event ) {
    event.preventDefault();

    onChange();
    Form.addEventListener( 'change', onChange, false );

    if ( hasError ) {
        scrollToError();
        return;
    } else {
        const url = Form.getAttribute( 'action' );
        let queryString = '?';
        queryString += 'name=' + FormName.value;
        queryString += '&email=' + FormEmail.value;
        queryString += '&organization=' + FormOrganization.value;
        queryString += '&role=' + FormRole.value;
        //queryString += '&reason=' + FormReason.value;
        queryString += '&message=' + FormMessage.value;
        queryString += '&suscribe=' + FormSuscribe.checked;
        queryString += '&nonce=' + FormNonce.value;

        const request = new XMLHttpRequest();
        request.onreadystatechange = function() {

            setButtonState( FormBtnSubmit, 'loading' );

            if ( request.readyState == 4 && request.status == 200) {
                let response = JSON.parse( request.response );
                if( response && response.status == 'success' ) {
                    showSuccess();
                }else {
                    showError();
                }
            } else if( request.readyState == 4 && request.status != 200 ) {
                showError();
            }
        }
        request.open( "GET", url + `${queryString}`, true );
        request.send();
    }
    return;
}

function onFocusIn() {
    let fieldType = this.type;
    if ( fieldType === 'checkbox' ) {
        this.parentNode.parentNode.classList.add( 'formbox--focused' );
    } else {
        this.parentNode.classList.add( 'formbox--focused' );
    }
}

function onFocusOut() {
    let field = this;
    let fieldType = field.type;

    if ( fieldType === 'checkbox' ) {
        field.parentNode.parentNode.classList.remove( 'formbox--focused' );
    } else {
        if( isEmpty( field ) ) {
            field.parentNode.classList.remove( 'formbox--focused' );
        }
    }
}

function cleanFocusedClass() {
    FormBox.forEach( formBox => {
        formBox.classList.remove( 'formbox--focused' );
    });
}

/**
 * Para que la función se ejecute correctamente el botón input tiene
 * que tener internamente <span> con la clase .button__text para
 * lograr la animación pertinente, por ejemplo:
 *
 * <button type="submit" class="button button--invert">
 *      <span class="button__text">Get in touch</span>
 * </button>
 */
function setButtonState( btn, state ) {

    if( !btn || !BtnSubmitText ) return;

    if( state === 'loading' ) {
        BtnSubmitText.textContent = message.loading;
        btn.classList.add( 'button--loading' );
        btn.disabled = true;
        return;
    }

    if( state === 'success' ) {
        BtnSubmitText.textContent = message.success;
        btn.classList.add( 'button--loaded' );

        setTimeout( function() {
            restoreButtonState( btn, backupBtnSubmitText );
        }, 4000 );
    }

    if( state === 'error' ) {
        restoreButtonState( btn, backupBtnSubmitText );
    }
}

function restoreButtonState( btn, txt ) {
    BtnSubmitText.textContent = txt;
    btn.classList.remove( 'button--loading' );
    btn.classList.remove( 'button--loaded' );
    btn.disabled = false;
}

export default Constructor;